import React from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import styles from './styles.module.css';

import BackgroundContainer from '../../components/background-container';

import GridWrap from '../../components/grid-wrap';
import SiteFooter from '../../components/site-footer';
import RoomImage from '../../images/room.jpg';

import ContactForm from './contact-form';

export default () => (
  <div>
    <Helmet title="Contact Us" />
    <BackgroundContainer src={RoomImage}>
      <div className={styles.top}>
        <GridWrap>
          <div className={styles.topContent}>
            <h1>Contact Us</h1>
          </div>
        </GridWrap>
      </div>
    </BackgroundContainer>

    <GridWrap>
      <div className={styles.content}>
        <ContactForm />
      </div>
    </GridWrap>
    <SiteFooter />
  </div>
);



// WEBPACK FOOTER //
// ./src/page-components/contact-us/index.js